/**
 * `fetch` com timeout via AbortController — em rede móvel ruim (iOS/WebView do WhatsApp)
 * um request pode ficar pendurado indefinidamente, travando a navegação sem feedback.
 * Rejeita com o AbortError quando estoura, como qualquer falha de rede.
 */
export async function fetchWithTimeout(
    input: RequestInfo | URL,
    init: RequestInit = {},
    timeoutMs = 10000,
): Promise<Response> {
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), timeoutMs);
    try {
        return await fetch(input, { ...init, signal: controller.signal });
    } finally {
        window.clearTimeout(timer);
    }
}
